<div class="BannerConfirmedFlightAfected">
  <img alt="" class="BannerConfirmedFlightAfected-image" src="./assets/images/whiteCheck.svg" />
  <span
    class="fs-22px fw-regular lh-28px text-am-white"
    [innerHTML]="'bannerConfirmedFlightAfected.title' | translate"
  >
  </span>
</div>